import { BaseApi, configuration } from '../../api/base/BaseApi';
import { StorageKey } from '../../util/Storage';

class ShadowLoginApi extends BaseApi {

    completeShadowLogin(tempToken: string): Promise<boolean> {

        const options: RequestInit = {
            method: 'GET',
            headers: {
                'secure-cookie': 'true'
            }
        };

        return this.fetch(configuration.basePath + '/shadowlogin/' + tempToken, options)
            .then(() => {
                localStorage.setItem(StorageKey.Authenticated, 'true');
                return Promise.resolve(true);
            })
            .catch(() => {
                localStorage.setItem(StorageKey.ApiError, 'Shadow Login Uncompleted');
                return Promise.resolve(false);
            });
    }

}

export const shadowLoginApi = new ShadowLoginApi();


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/shadowlogin/ShadowLoginApi.ts